import RegistrationModal from '@/components/dashboard/registration-modal/RegistrationModal.vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

const mountEl = document.getElementById('registration-modal-container');

if (mountEl) {
  const app = createApp(RegistrationModal);
  const pinia = createPinia();
  app.use(pinia);
  app.mount(mountEl);
}
